export default "__VITE_ASSET__eCDmLZYk__"